import { render, staticRenderFns } from "./SubAgentPanel.vue?vue&type=template&id=30cc0a37&scoped=true"
import script from "./SubAgentPanel.vue?vue&type=script&lang=js"
export * from "./SubAgentPanel.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=30cc0a37&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc0a37",
  null
  
)

export default component.exports